import ajax from '../ajax'


 //ERP /api/account/price
export function  ERPPriceApi(params) {
    return ajax({
        method:'get',
        url: 'api/account/price',
        params
    })
}



/// api/account/saveprice
export function ERPSaveprice(data) {
    return ajax({
        method:'post',
        url: 'api/account/saveprice',
        data
    })
}




///api/account/index
export function  ERPIndexApi(params) {
    return ajax({
        method:'get',
        url: 'api/account/index',
        params
    })
}


///api/account/search
export function  ERPSearchApi(params) {
    return ajax({
        method:'get',
        url: 'api/account/search',
        params
    })
}


// /api/account/info?id=8

export function  ERPInfoApi(params) {
    return ajax({
        method:'get',
        url: 'api/account/info',
        params
    })
}


///api/account/edit   post
export function  ERPEditApi(data) {
    return ajax({
        method:'post',
        url: 'api/account/edit',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/user_account/index.js